import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4f8b1f63"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "team-container"
}
const _hoisted_2 = { class: "global-unit" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "teamName",
  class: "global-label"
}, "チーム名", -1))
const _hoisted_4 = { class: "global-unit" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "teamShortName",
  class: "global-label"
}, "省略チーム名", -1))
const _hoisted_6 = { class: "global-unit" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "category",
  class: "global-label"
}, "カテゴリ", -1))
const _hoisted_8 = { class: "global-select" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: null,
  disabled: ""
}, "カテゴリを選ぶ", -1))
const _hoisted_10 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.team.data != undefined)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _withDirectives(_createElementVNode("input", {
            id: "teamName",
            type: "text",
            class: "global-input",
            readonly: "",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.team.data.name) = $event))
          }, null, 512), [
            [_vModelText, _ctx.team.data.name]
          ])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _withDirectives(_createElementVNode("input", {
            id: "teamShortName",
            type: "text",
            class: "global-input",
            readonly: "",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.team.data.short_name) = $event))
          }, null, 512), [
            [_vModelText, _ctx.team.data.short_name]
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createElementVNode("div", _hoisted_8, [
            _withDirectives(_createElementVNode("select", {
              class: "select",
              disabled: "",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.team.data.category_id) = $event))
            }, [
              _hoisted_9,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.teamCategories.list, (category) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: category.id,
                  value: category.id
                }, _toDisplayString(category.name), 9, _hoisted_10))
              }), 128))
            ], 512), [
              [_vModelSelect, _ctx.team.data.category_id]
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}